import { gql } from '@apollo/client';

import { BREAKDOWN_FIELDS } from 'gql/breakdownFragment';

export const FETCH_ASSIGNMENTS_WITH_FILTERS = gql`
	query fetchWorkAssignment($filter: WorkAssignmentSearchFilterV2!, $pagination: PaginationInput!) {
		workAssignmentSearchV2(pagination: $pagination, filter: $filter) {
			results {
				sequenceGroupId
				reconciliationStatus
				isProblematic
				isEditable
				status
				crewMember {
					fullName
					driverCard
					id
					phone
					currentRun {
						name
					}
					currentJobs {
						code
					}
					currentEmploymentType {
						employmentType
					}
					currentHomeBase {
						city {
							name
							id
						}
					}
				}
				run {
					name
				}
				job {
					code
					distanceKm
					durationSeconds
				}
				breakdown {
					...BreakdownFields
				}
				workAssignmentSequences {
					sequenceGroupId
					ride {
						id
						tripNumber
						lineCode
						departure
						stations {
							id
							code
							name
							departure
							arrival
							timezone
						}
					}
					line {
						code
					}
					workAssignments {
						id
						version
						fromTimestamp
						toTimestamp
						fromStation {
							id
							code
							timezone
						}
						toStation {
							id
							code
							timezone
						}
					}
					fromTimestamp
					toTimestamp
					fromStation {
						code
						name
						id
						timezone
					}
					toStation {
						code
						name
						id
						timezone
					}
					status
					extraActivities {
						activityType
						fromStation {
							code
						}
						toStation {
							code
						}
						fromTimestamp
						toTimestamp
					}
				}
			}
			page {
				size
				page
				totalPages
				totalCount
			}
		}
	}
	${BREAKDOWN_FIELDS}
`;
